document.addEventListener('DOMContentLoaded', async function() {
  const elem = document.querySelector('.testimonial-carousel__testimonials');
  
  if (!elem) return;
  
  try {
    // Use the theme's LibraryLoader to load Flickity
    await window.LibraryLoader.load("flickity");
    
    // Create Flickity instance using the theme's implementation
    const flkty = new window.ThemeFlickity(elem, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      autoPlay: 3000,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      pageDots: true,
      draggable: false,
      dragThreshold: 10,
      adaptiveHeight: false,
      percentPosition: false,
      rightToLeft: window.themeVariables?.settings?.direction === "rtl",
      accessibility: window.MediaFeatures?.supportsHover?.() || false
    });
    
    // Progress indicator functionality
    let progressInterval;
    const slideDuration = 3000; // 3 seconds
    
    function startProgressAnimation() {
      const activeDot = elem.parentElement.querySelector('.flickity-page-dots .dot.is-selected');
      if (!activeDot) return;
      
      // Reset progress
      activeDot.style.setProperty('--progress-width', '0%');
      
      // Clear any existing interval
      if (progressInterval) {
        clearInterval(progressInterval);
      }
      
      // Start progress animation
      const startTime = Date.now();
      progressInterval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min((elapsed / slideDuration) * 100, 100);
        
        activeDot.style.setProperty('--progress-width', `${progress}%`);
        
        if (progress >= 100) {
          clearInterval(progressInterval);
        }
      }, 16); // ~60fps
    }
    
    function stopProgressAnimation() {
      if (progressInterval) {
        clearInterval(progressInterval);
      }
    }
    
    // Listen for slide changes
    flkty.on('change', function(index) {
      // stopProgressAnimation();
      setTimeout(startProgressAnimation, 100); // Small delay to ensure DOM is updated
    });
    
    // Start progress animation on first load
    setTimeout(startProgressAnimation, 100);
    
  } catch (error) {
    console.error('Error initializing testimonial carousel:', error);
  }
});
